<template>
  <div
    :class="{
      displayBorder: displayBorder,
      displayTitle: displayTitle,
      displayFilled: displayFilled,
      displayPlain: displayPlain,
      displayPlainHeader: displayPlainHeader,
      selectable: node.drilldown || allowExpand,
      actionPending: node.actionPending,
      showAsLink: isLink,
    }"
    @click="node.drilldown ? doAction('drilldown') : isLink ? $emit('viewNodeDoc', $event) : $emit('click', $event)"
    :title="node.name"
    :style="customStyle"
    @contextmenu="openContextMenu($event)"
  >
    <v-icon
      v-if="treeExpand && node.nodes && node.nodes.length"
      class="float-left"
      :style="customStyle"
      >{{
        node.expanded ? "mdi-minus-box-outline" : "mdi-plus-box-outline"
      }}</v-icon
    >
    <v-icon
      v-if="node.actionPending"
      title="Action Pending!"
      class="float-right"
      color="red"
      @click.stop="removePendingAction"
      >mdi-alert-decagram</v-icon
    >
    <div
      :class="{
        overflow: displayBorder || displayTitle || treeExpand || displayFilled || displayPlain || displayPlainHeader,
      }"
      :style="
        treeExpand ? 'width: calc(100% - 30px); display: inline-block;' : ''
      "
    >
      <v-tooltip top v-if="!displayTitle && !hideDrilldown && node.drilldown">
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-if="displayPlain || displayPlainHeader" v-bind="attrs" v-on="on" :style="customStyle">
            {{ node.drilldown.expanded ? 'mdi-chevron-down' : 'mdi-chevron-right' }}
          </v-icon>
          <v-icon v-else small v-bind="attrs" v-on="on" :style="customStyle">
            mdi-chevron-triple-down
          </v-icon>
        </template>
        <span>Drilldown to {{ node.nextLevel }} for: {{ node.name }}</span>
      </v-tooltip>
      <!-- <v-icon
        v-if="nodeSelectable"
        :color="node.selected ? 'green' : 'gray'" class="mx-2" style="font-size: 18px;"
        :style="customStyle" @click.stop="$emit('nodeSelected')"
        >{{
          node.selected ? "mdi-checkbox-marked" : "mdi-checkbox-blank-outline"
        }}</v-icon
      > -->
      <CheckBox class="ml-2" style="display: inline-block; margin-top: -8px; margin-bottom: -8px; margin-right: -8px;
        vertical-align: sub;"
        v-if="nodeSelectable" :item="node" @click="$emit('nodeSelected')"
      ></CheckBox>
      <v-icon v-if="allowExpand" :style="customStyle">{{
        node.show ? "mdi-chevron-up" : "mdi-chevron-down"
      }}</v-icon>
      <template v-if="!hideDescriptor && node.descriptor">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              right
              @click.stop="doAction('editHierarchyDescriptor')"
              v-bind="attrs"
              v-on="on"
              :style="customStyle"
            >
              mdi-information
            </v-icon>
          </template>
          <span>Description: {{ node.descriptor.description }}</span>
        </v-tooltip></template
      >
          <v-icon small right :style="customStyle" v-if="!hideNodeActions && !displayPlain && !displayPlainHeader"
            @click.stop="openContextMenu($event)">
            mdi-dots-vertical-circle-outline
          </v-icon>
          <v-icon v-else-if="!hideNodeActions && !nodeActionsAlignment || nodeActionsAlignment === 'right'" right class="float-right" style="color: #aaaaaa;"
            @click.stop="openContextMenu($event)">
            mdi-dots-horizontal
          </v-icon>
      <v-tooltip
        v-if="displayNameHistory && node.nameHistory && node.nameHistory.length"
        top
      >
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            small
            color="purple"
            right
            v-bind="attrs"
            v-on="on"
            :style="customStyle"
          >
            mdi-rename-box-outline
          </v-icon> </template
        ><v-list dense
          ><v-subheader>Previous Names:</v-subheader
          ><v-list-item v-for="(h, hi) in node.nameHistory" :key="'nh' + hi"
            ><v-list-item-content>{{ h }}</v-list-item-content></v-list-item
          ></v-list
        >
      </v-tooltip>
      <v-tooltip
        v-if="
          !hideReview &&
          node.reviewStatus &&
          node.reviewStatus.docsAsParent_open &&
          node.reviewStatus.docsAsParent_open.length
        "
        top
      >
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            small
            right
            @click.stop="doAction('showReviewParent')"
            v-bind="attrs"
            v-on="on"
            :color="node.reviewStatus.hasDataAsParent ? 'orange' : 'blue'"
            :style="customStyle"
          >
            mdi-eye-settings-outline
          </v-icon>
        </template>
        <span
          >Has {{ node.nextLevel }}s currently
          {{
            node.reviewStatus.docsAsParent_open[0].status +
            (node.reviewStatus.hasDataAsParent
              ? " (has feedback)"
              : " (no feedback)")
          }}</span
        >
      </v-tooltip>
      <v-tooltip
        v-if="
          !hideReview && node.reviewStatus && node.reviewStatus.docs_open.length
        "
        top
      >
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            small
            right
            @click.stop="doAction('showReview')"
            v-bind="attrs"
            v-on="on"
            :color="node.reviewStatus.hasData ? 'orange' : 'blue'"
          >
            mdi-eye-settings
          </v-icon>
        </template>
        <span
          >Currently
          {{
            node.reviewStatus.docs_open[0].status +
            (node.reviewStatus.hasData ? " (has feedback)" : " (no feedback)")
          }}</span
        >
      </v-tooltip>
      <v-icon v-if="nodeActionsAlignment === 'left' && !hideNodeActions" right style="color: #aaaaaa;" class="mr-1"
            @click.stop="openContextMenu($event)">
            mdi-dots-horizontal
          </v-icon>
          <span v-html="utils.highlightSearchTerms(node.name, searchTerms)"></span>
      <!-- {{ node.name }} -->
      <v-icon
        v-if="displayStatus"
        style="padding-left: 5px"
        :color="node.active ? 'green' : 'red'"
        >{{
          node.active ? "mdi-check-circle" : "mdi-emoticon-dead-outline"
        }}</v-icon
      ><v-icon v-if="nodeActionsAlignment === 'inline' && !hideNodeActions" right style="color: #aaaaaa;"
            @click.stop="openContextMenu($event)">
            mdi-dots-horizontal
          </v-icon>
    </div>
    <v-menu
      v-if="!node.actionPending && !hideNodeActions"
      v-model="contextMenu.show"
      absolute
      :position-x="contextMenu.posX"
      :position-y="contextMenu.posY"
      offset-y
      :close-on-content-click="false"
      nudge-width="300"
    >
      <v-card>
        <v-card-text v-if="contextMenu.busy">
          <v-row>
            <v-col cols="5"></v-col>
            <v-col>
              <v-progress-circular indeterminate size="50" color="grey">
              </v-progress-circular>
            </v-col>
            <v-col cols="5"></v-col>
          </v-row>
        </v-card-text>
        <v-list dense v-else>
          <v-list-item>
            <v-list-item-title
              ><div class="menuSubject">
                {{ contextMenu.title }}
              </div></v-list-item-title
            ></v-list-item
          >
          <v-list-item
            v-for="(a, ai) in contextMenu.actions"
            :key="'cma' + ai"
            @click="doContextMenuAction(a)"
          >
            <v-list-item-icon>
              <v-icon :color="a.colour || 'gray'">{{ a.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ a.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import CheckBox from "@/components/jobArchitecture/CheckBox";
import utils from "@/common/utils.js";
export default {
  name: "cHierarchyNodeDisplay",
  props: {
    node: Object,
    allowExport: Boolean,
    allowExpand: Boolean,
    hideDrilldown: Boolean,
    hideDescriptor: Boolean,
    displayBorder: Boolean,
    displayFilled: Boolean,
    displayTitle: Boolean,
    displayPlain: Boolean,
    displayPlainHeader: Boolean,
    hideEdit: Boolean,
    hideReview: Boolean,
    listviewColumn: Object,
    listviewItem: Object,
    treeExpand: Boolean,
    displayStatus: Boolean,
    displayNameHistory: Boolean,
    customStyle: Object,
    nodeActionsAlignment: String,
    nodeSelectable: Boolean,
    isLink: Boolean,
    searchTerms: { type: [], required: false },
    hideNodeActions: { type: Boolean, required: false },
  },
  data: function () {
    return {
      utils: utils,
      contextMenu: {
        show: false,
        busy: false,
        item: null,
        title: null,
        actions: [],
        posX: 0,
        posY: 0,
      },
      actionMenu: false,
      actions: [],
    };
  },
  components: { 
    CheckBox, 
  },
  watch: {
    actionMenu: function (val) {
      if (val) this.getActions();
      else this.actions = [];
    },
  },
  computed: {},
  created: function () {},
  methods: {
    doAction(actionName, action) {
      this.actionMenu = false;
      this.$emit("action", {
        action: actionName,
        actionDef: action,
        node: this.node,
        listviewColumn: this.listviewColumn,
        listviewItem: this.listviewItem,
      });
    },
    openContextMenu_(event) {
      this.$emit("contextmenu", event, this.node);
    },
    async openContextMenu(e) {
      e.preventDefault();
      if (this.hideNodeActions) return;
      this.contextMenu.show = false;
      this.contextMenu.posX = e.clientX;
      this.contextMenu.posY = e.clientY;
      this.contextMenu.title = this.node.name;
      await this.getActions();
      this.contextMenu.actions = this.actions;
      this.$nextTick(() => {
        this.contextMenu.show = true;
      });
    },
    doContextMenuAction(action) {
      this.doAction(action.type, action);
      this.contextMenu.show = false;
    },
    async getActions() {
      let actions = [];
      await this.$store
        .dispatch("hierarchies/getNodeActions", {
          hierarchy_node_id: this.node.hierarchy_node_id,
          allowExport: this.allowExport,
          hideReview: this.hideReview,
          reviewStatus: this.node.reviewStatus,
          documentType: this.node.canAddDocumentType,
        })
        .then((resp) => {
            if (resp.data.Status === "OK") {
              actions = resp.data.Data.actions.filter(x => x.type !== "displayLinkedDocumentTags");
            }
        }),
        (error) => {
          console.error(error);
          // this.isLoading = false;
			};
      if (this.listviewColumn) {
        if (
          this.listviewColumn.filterSettings.values.some(
            (x) => x.selected && x.text === this.node.name
          )
        ) {
          actions.unshift({
            title: `Remove from Filter`,
            icon: "mdi-filter-minus-outline",
            type: "removeFilter",
            column: null,
          });
        } else {
          actions.unshift({
            title: `Add to filter`,
            icon: "mdi-filter-plus-outline",
            type: "addFilter",
            column: null,
          });
        }
      }
      this.actions = actions;
    },
    removePendingAction() {
      this.$emit("removeActionPending");
    },
  },
};
</script>

<style scoped lang="scss">
.displayBorder,
.displayFilled {
  border-radius: 5px;
  display: block;
  // height: 24px;
  font-size: 12px;
  padding-left: 6px;
  padding-right: 6px;
  font-weight: bold;
  width: 100%;
}
.displayPlain, .displayPlain > div {
  font-family: "MD Sans", sans-serif !important;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.5px;
  border: none;
  background-color: inherit;
}
.displayPlainHeader, .displayPlainHeader > div {
  font-family: "MD Sans", sans-serif !important;
  font-weight: 700;
  font-size: 14px;
  // line-height: 20.83px;
  letter-spacing: 0.5px;
  border: none;
  background-color: inherit;
}
.displayBorder {
  border: solid 1px #b7d1cd; /* #004d40; */
  background-color: white;
}
.displayFilled {
  background-color: #f6f0f0;
}
.displayTitle {
  border: solid 1px #004d40;
  border-radius: 5px;
  display: block;
  height: 36px;
  font-family: "MD Sans", sans-serif;
  font-size: 16px;
  padding-left: 6px;
  padding-right: 6px;
  font-weight: bold;
  //   width: 100%;
}
.overflow {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  //   width: 100%;
}
.selectable {
  cursor: pointer;
}
.actionPending {
  background-color: #ffab91;
}
.showAsLink {
  text-decoration: underline;
}
.showAsLink:hover {
  color: green;
  cursor: pointer;
}
</style>